export default __webpack_public_path__ + "static/media/SURVIVE_4.7ea9c854.jpg";